import React from 'react';
import { Button, Tooltip } from 'antd';
import { useNetworkManager } from '../../hooks/useNetworkManager';
import { useTheme } from '../../theme/ThemeProvider';

function getButtonStyle(isDark, disabled) {
  if (isDark) {
    if (disabled) {
      return {
        opacity: 1,
        backgroundColor: 'rgb(31, 41, 55)',
        color: '#a1a1aa',
        border: '1px solid rgba(255, 255, 255, 0.06)',
      };
    }
    return {
      opacity: 1,
      backgroundColor: '#c1ff72',
      color: '#000000',
      border: 'none',
    };
  }

  if (disabled) {
    return {
      opacity: 1,
      backgroundColor: '#ffffff',
      color: 'rgba(0, 0, 0, 0.45)',
      border: '1px solid rgba(0, 0, 0, 0.12)',
    };
  }

  return {
    opacity: 1,
    backgroundColor: '#ffffff',
    color: '#000000',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  };
}

const NetworkManager = () => {
  const { isDark } = useTheme();
  const {
    isAddingNetwork,
    networkStatus,
    addNetwork,
  } = useNetworkManager();

  const handleClick = async () => {
    await addNetwork();
  };

  const getButtonContent = () => {
    switch (networkStatus.status) {
      case 'wrong-network':
        return {
          icon: <img src="/images/svg/brands/metamask.svg" alt="Metamask" width={16} height={16} style={{ marginRight: '4px' }} />,
          text: 'Add Mova Network',
          disabled: false,
        };
      case 'connected':
        return {
          icon: <img src="/images/svg/brands/metamask.svg" alt="Metamask" width={16} height={16} style={{ marginRight: '4px' }} />,
          text: 'Add Mova Network',
          disabled: true,
        };
      default:
        return {
          icon: <img src="/images/svg/brands/metamask.svg" alt="Metamask" width={16} height={16} style={{ marginRight: '4px' }} />,
          text: 'Add Mova Network',
          disabled: false,
        };
    }
  };

  const buttonContent = getButtonContent();
  const buttonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    minWidth: '140px',
    fontSize: '12px',
    borderRadius: '5px',
    boxShadow: 'none',
    ...getButtonStyle(isDark, buttonContent.disabled),
  };

  const getTooltipTitle = () => {
    switch (networkStatus.status) {
      case 'wrong-network':
        return 'Add Mova Network to MetaMask';
      case 'connected':
        return 'Already connected to Mova Network';
      case 'not-connected':
        return 'Connect your wallet first';
      default:
        return '';
    }
  };

  if (networkStatus.status === 'no-metamask') {
    return null;
  }

  const button = (
    <Button
      type="default"
      className="network-manager-btn"
      icon={buttonContent.icon}
      loading={isAddingNetwork}
      disabled={buttonContent.disabled}
      onClick={handleClick}
      size="small"
      style={buttonStyle}
    >
      {isAddingNetwork ? 'Adding...' : buttonContent.text}
    </Button>
  );

  return (
    <Tooltip title={getTooltipTitle()}>
      {buttonContent.disabled ? <span className="d-inline-block">{button}</span> : button}
    </Tooltip>
  );
};

export default NetworkManager;
